module.exports = __webpack_public_path__ + "static/img/incheon-investment.fb30174.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/incheon-investment.jpg
// module id = cj7u
// module chunks = 0